import store from "../store/index";
//---------------------
// get combatant by id
//---------------------
export default function getCombatantById(id) {
  //-----------
  // get store
  //-----------
  const this_store_combat = store.state.combat;
  let combatant = this_store_combat.arena.arena_combatants.find((a) => a.id == id);
  return combatant;
}
